import { useContext } from 'react';
import { mapModes } from '../../constants/map';
import { MapContext } from '../../contexts/MapContext';

import SectionMenu from './SectionMenu';
import RowMenu from './RowMenu';
import LayerMenu from './LayerMenu';
import SuitabilityMenu, { SUITABILITY_LAYER_ID } from './SuitabilityMenu';
import BaseLayerMenu, { BASE_LAYER_ID } from './BaseLayerMenu';
import FieldsPageFarmSummary from './FieldsPageFarmSummary';
import LandUseLayerMenu, { LAND_USE_LAYER_ID } from './LandUseLayerMenu';
import ClimateLayerMenu, { CLIMATE_LAYER_ID } from './ClimateLayerMenu';

const FieldsMenuContent = ({ readonly, colors }) => {
  const {
    fields: { fieldSections },
    mapState: {
      mapMode,
      activeField,
      activeRowIndexes,
      activeLayerId,
      activeLayerFeatureId,
      selectedFieldIds,
    },
  } = useContext(MapContext);

  const selectedSections = [
    mapModes.MULTI_SECTION_SELECT,
    mapModes.SECTION_GROUP_ENGAGED,
  ].includes(mapMode)
    ? fieldSections.filter((section) => selectedFieldIds.has(section.id))
    : fieldSections;

  return [
    mapModes.VIEW,
    mapModes.MULTI_SECTION_SELECT,
    mapModes.SECTION_GROUP_ENGAGED,
    mapModes.MEASUREMENT,
  ].includes(mapMode) ? (
    <FieldsPageFarmSummary
      fieldSections={selectedSections}
      readonly={readonly}
      colors={colors}
    />
  ) : activeLayerId ? (
    activeLayerId === SUITABILITY_LAYER_ID ? (
      <SuitabilityMenu />
    ) : activeLayerId === LAND_USE_LAYER_ID ? (
      <LandUseLayerMenu />
    ) : activeLayerId === CLIMATE_LAYER_ID ? (
      <ClimateLayerMenu />
    ) : activeLayerId === BASE_LAYER_ID ? (
      <BaseLayerMenu readonly={readonly} />
    ) : (
      <LayerMenu
        layerId={activeLayerId}
        featureId={activeLayerFeatureId}
        readonly={readonly}
      />
    )
  ) : mapMode === mapModes.ROW_ENGAGED ? (
    <RowMenu
      section={activeField}
      readonly={readonly}
      activeRowIndexes={activeRowIndexes}
      colors={colors}
    />
  ) : (
    <SectionMenu section={activeField} readonly={readonly} colors={colors} />
  );
};

export default FieldsMenuContent;
